export default __webpack_public_path__ + "static/media/DCI.9c01b6ba.png";